import get from 'lodash.get';
import { fromJS } from 'immutable';

import logger from 'logger';
import { IMPERSONATE_KEY } from 'enum/profile';
import { Studio, User } from 'stores/UserStore/UserStore.types';


type Username = User['username'];

/**
 * This method will return current impersonated user or username received as argument if no impersonate user
 * in the session storage.
 * The second argument can be used if you want to get back the whole user object
 */
export const usernameOrImpersonate = (
  currentUsername: Username = null,
  fullImpersonateUserObject = false
): User | Username | null => {
  let userOrUsername: User | Username = currentUsername;
  if (sessionStorage.getItem(IMPERSONATE_KEY) && sessionStorage.getItem(IMPERSONATE_KEY) !== 'undefined') {
    try {
      userOrUsername = sessionStorage.getItem(IMPERSONATE_KEY);

      if (fullImpersonateUserObject) {
        userOrUsername = JSON.parse(userOrUsername);
      } else {
        userOrUsername = JSON.parse(userOrUsername) as User;
        userOrUsername = userOrUsername.username;
      }
    } catch (err) {
      logger.warn(err);
    }
  }

  return userOrUsername;
};

/**
 * Returns null if impersonated user is not studio
 * Returns studio object if impersonated as studio
 */
export const impersonatedStudio = (): Studio | null => {
  const isImpersonateAsStudio =
    usernameOrImpersonate() && get(usernameOrImpersonate('', true), 'studio.username', false);
  if (isImpersonateAsStudio) {
    return get(usernameOrImpersonate('', true), 'studio', null);
  }

  return null;
};

/**
 * Find a property under studio object,
 * if impersonated user is not admin, will return the default passed value
 */
export const propFromImpersonatedStudio = (
  prop: PropertyKey,
  defaultValue: Studio[keyof Studio],
  asImmutable = false
): any => {
  let value = defaultValue;
  const studio = impersonatedStudio();

  if (studio && Object.prototype.hasOwnProperty.call(studio, prop)) {
    if (asImmutable) {
      value = fromJS(get(studio, prop));
    } else {
      value = get(studio, prop);
    }
  }

  return value;
};

export const getUsernameOrImpersonate = (username: Username): Username => {
  let impersonatedUser: Username = '';
  if (usernameOrImpersonate() !== null) {
    impersonatedUser = usernameOrImpersonate() as Username;
  } else {
    impersonatedUser = username;
  }

  return impersonatedUser;
};

export const isImpersonatedUser = (): boolean => usernameOrImpersonate() !== null;
